var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 230",
    style: {
      enableBackground: "new 0 0 300 230"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.9,9c12.1,0.3,23.8,0.5,35.7,0.8c-0.2,15.1,4.1,28.6,14.1,39.7C221.1,60.9,235.3,63,250,63.4c0,12.4,0,24.7,0,37.4 c-19.1,0.8-36.8-4.1-53.3-13.9c-0.1,0.5-0.3,0.9-0.3,1.3c0.1,21.5,0.1,43.1,0.3,64.6c0.1,15.9-4,30.4-13.4,43.2 c-9.8,13.3-23.1,21.5-39.2,24.9c-21.5,4.5-41.4,0.6-59-13.1c-13.2-10.4-20.5-24.3-23.7-40.7c-2.4-12.8-1.8-25.4,3.4-37.3 c9.8-22.9,27-37,51.5-42.1c7.3-1.5,14.5-1.5,21.8-0.4c0.6,0.1,1.6,1,1.6,1.5c0.1,11.4,0,22.7,0,34.1c0,0.2-0.1,0.4-0.2,0.6 c-2.7-0.5-5.4-1.1-8.1-1.4c-16.5-1.8-32.7,10.5-35,26.9c-2.1,15.2,4.2,29.2,18.8,35.3c13.8,5.8,30.4,1.8,39.5-9.7 c5-6.3,6.2-13.7,6.2-21.5c0-47,0-94,0-140.9C160.9,11.3,160.9,10.4,160.9,9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.1029b06ea01baa4129cb3fc386c753a1.svg";
export { ForwardRef as ReactComponent };